import manager from "./manager";
import fdx from "./fdx";
import hzzj from "./hzzj";
import kaisa from "./kaisa";

var context = require.context("./", true, /^(?!internals).*\/(?!.*index).*\.js$/);
var routeList = [];
context.keys().forEach(routes => {
  routeList = routeList.concat(context(routes).default);
});

export default routeList;
export {
  manager,
  fdx,
  hzzj,
  kaisa
};



// WEBPACK FOOTER //
// ./src/router/modules/index.js